"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionManager = void 0;
class SubscriptionManager {
    constructor(initialSubscriptions) {
        this.subscriptions = initialSubscriptions || [];
    }
    add(subscription) {
        this.subscriptions.push(subscription);
    }
    remove(subscription) {
        const index = this.subscriptions.findIndex(sub => sub === subscription);
        if (index > -1) {
            this.subscriptions[index].unsubscribe();
            this.subscriptions.splice(index, 1);
        }
    }
    addSubscriptions(subscriptions) {
        this.subscriptions = this.subscriptions.concat(subscriptions);
    }
    unsubscribeAll() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.subscriptions.splice(0, this.subscriptions.length);
    }
}
exports.SubscriptionManager = SubscriptionManager;
//# sourceMappingURL=subscription_manager.js.map